import { API_URL } from '@/shared/utils/apiConfig';
import { fetchAuthenticatedObjectUrl } from './avatarObjectUrlCache';
import { isBrowserNativeAvatarSrc, resolveAvatarImgSrc } from './resolveAvatarImgSrc';

/** True when the browser can load the avatar URL (signed path or authenticated blob). */
export function verifyAvatarSrcLoads(apiSrc: string | null | undefined): Promise<boolean> {
  if (!apiSrc) return Promise.resolve(false);

  if (isBrowserNativeAvatarSrc(apiSrc)) {
    const src = resolveAvatarImgSrc(apiSrc, {});
    if (!src) return Promise.resolve(false);
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = src;
    });
  }

  return fetchAuthenticatedObjectUrl(apiSrc).then((url) => Boolean(url));
}

export function prefetchAvatarSrc(apiSrc: string | null | undefined): void {
  if (!apiSrc) return;

  if (isBrowserNativeAvatarSrc(apiSrc)) {
    const src = apiSrc.startsWith('http')
      ? apiSrc
      : `${API_URL}${apiSrc.startsWith('/') ? apiSrc : `/${apiSrc}`}`;
    const img = new Image();
    img.decoding = 'async';
    img.src = src;
    return;
  }

  void fetchAuthenticatedObjectUrl(apiSrc);
}
